module.exports = __webpack_public_path__ + "img/quickspin.c9cf631e.png";